import React from 'react';
import PropTypes from 'prop-types';

const TableHeader = ({
  day, date,
}) => (
  <td> {day} <br />
    {date}
  </td>
);

TableHeader.propTypes = {
  day: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
};

export default TableHeader;



// WEBPACK FOOTER //
// ./src/components/Resource/components/TableHeader.jsx